import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Features } from './components/Features';
import { FAQ } from './components/FAQ';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
import { LyricsDivider } from './components/LyricsDivider';
export function App() {
  return <div className="min-h-screen bg-gradient-to-b from-indigo-50 to-white" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <LyricsDivider lyrics="As someone told me lately, 'Everyone deserves the chance to fly'" attribution="Defying Gravity by Idina Menzel (from the musical Wicked)" data-id="element-5" />
        <Features data-id="element-6" />
        <LyricsDivider lyrics="My mama told me when I was young, 'We are all born superstars'" attribution="Born This Way by Lady Gaga" data-id="element-7" />
        <FAQ data-id="element-8" />
        <LyricsDivider lyrics="And you'll finally see the truth, that a hero lies in you." attribution="Hero by Mariah Carey" data-id="element-9" />
        <ContactForm data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}